<template>
  <footer class="footer-container text-xl px-[140px] pt-[50px] pb-5">
    <n-grid cols="3">
      <!-- <n-grid-item>
        <FTListItem
          title="产品服务"
          :list="['司普大语言模型应用', '司普智能数采平台']"
        />
      </n-grid-item> -->
      <n-grid-item>
        <FTListItem
          title="行业解决方案"
          :list="[
            {
              content: '金融保险行业解决方案',
              to: '/home/industry-solutions/education?id=1'
            },
            {
              content: '医药行业解决方案',
              to: '/home/industry-solutions/education?id=2'
            },
            {
              content: '教育行业解决方案',
              to: '/home/industry-solutions/education?id=3'
            },
            {
              content: '电力行业解决方案',
              to: '/home/industry-solutions/education?id=4'
            }
          ]"
        />
      </n-grid-item>
      <n-grid-item>
        <FTListItem title="关于司普" :list="['公司简介', '联系我们']" />
      </n-grid-item>
      <n-grid-item class="last-ft-list">
        <img
          class="w-[100px] h-[36px] object-cover mb-[20px]"
          src="../assets/img/logo-white.png"
          alt=""
        />
        <p class="text-sm mb-[20px]">深圳市司普科技有限公司</p>
        <p class="text-sm mb-[16px]">联系方式</p>
        <div class="flex gap-[25px] text-center text-sm">
          <div>
            <img
              src="@/assets/img/wechat-official-account.png"
              class="mb-4 w-[6.75rem] h-[6.75rem]"
            />
            <span class="mt-[18px]">官方公众号</span>
          </div>
          <div>
            <img
              src="@/assets/img/wechat.png"
              class="mb-4 w-[6.75rem] h-[6.75rem]"
            />
            <span>商务合作</span>
          </div>
        </div>
      </n-grid-item>
      <n-grid-item span="4">
        <n-divider style="margin-top: 30px; margin-bottom: 16px" />
      </n-grid-item>
      <n-grid-item span="4">
        <div class="text-xs">
          <small class="block"
            >深圳市司普科技有限公司 保留所有权利
            <a
              href="https://beian.miit.gov.cn"
              target="_blank"
              class="underline-offset-2 hover:underline"
              >粤ICP备2023079211号-1</a
            >
            - 单位门户网站 法律声明
            <img
              src="@/assets/img/110.png"
              width="14"
              height="14"
              class="icon-110 inline-block"
            />
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002002479"
              rel="noreferrer"
              target="_blank"
              class="inline-block underline-offset-2 hover:underline"
              >粤公网安备44030002002479</a
            >
          </small>
          <small class="block">
            深公网安备 3101060245673171号深圳市互联网违法和不良信息举报中心
            隐私政策
          </small>
        </div>
      </n-grid-item>
    </n-grid>
    <!-- <div >
      <div>
        <n-space>
          <div class="last-ft-list">
            <FTListItem
              title="司普"
              :list="[
                '联系电话：173 8875 5868  张先生',
                [
                  {
                    content: '公司地址：'
                  },
                  {
                    content:
                      '深圳市福田区梅林街道中康路136号深圳新一代产业园5栋6层018',
                    style: 'width: 260px'
                  }
                ]
              ]"
            />
          </div>
        </n-space>
      </div>
      <n-divider style="margin-bottom: 10px"></n-divider>
      
    </div> -->
  </footer>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
$border-color: #7e8baf;
.footer-container {
  background: url('@/assets/img/footer-bg.png') no-repeat center center;
  background-size: cover;
  color: rgba(255, 255, 255, 0.6);
  box-sizing: border-box;
  .last-ft-list {
    padding-left: 21%;
    border-left: 1px solid $border-color;
  }
  .icon-110 {
    margin-right: 2px;
    vertical-align: sub;
    margin-left: 14px;
  }
}
:deep(.n-divider .n-divider__line) {
  background-color: $border-color;
}
</style>
